import { translate } from "@/utils/formatters";
import regnskogfondet from "../../../public/regnskogfondet.png";
import Image from "next/image";

import styles from "./RegnskogSection.module.css";

interface RegnskogSectionProps {
  lang: string;
}

export const RegnskogSection = ({ lang }: RegnskogSectionProps) => {
  return (
    <div className={`box ${styles.container}`}>
      <a
        className={styles.link}
        href="https://www.regnskog.no/no/zeipt-receipt"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Image
          className="merchant-logo"
          src={regnskogfondet}
          alt="Regnskogsfondet logo"
        />
      </a>

      <h5>
        {translate(
          lang,
          "Ingen trær ble skadet med denne kvitteringen",
          "No trees were harmed with this receipt"
        )}
      </h5>
    </div>
  );
};
